import { default as OLMousePosition } from 'ol/control/MousePosition';
import RControlBase from './RControlBase';
export default class RMousePosition extends RControlBase {
    constructor(props, context) {
        super(props, context);
        this.ol = new OLMousePosition(this.toOLProps(props));
    }
    toOLProps(props) {
        return Object.assign(Object.assign({}, super.toOLProps(props)), { coordinateFormat: props.coordinateFormat, projection: props.projection, placeholder: props.placeholder || '&nbsp' });
    }
}
//# sourceMappingURL=RMousePosition.js.map